/* ==================== Desktop Currency Selector ==================== */
const $currencySelectorForm = $('#currency_form');
if ($currencySelectorForm.length > 0) {
  var $currencySelector = $currencySelectorForm.find('.currency-selector');
  $currencySelector.on('change', ()=>{
    $currencySelectorForm.trigger('submit');
  });
}

const $fakeCurrencySelector = $('.fake-currency-selector');
const $fakeCurrencySelected = $fakeCurrencySelector.find('.currency-selected');
const $fakeCurrencyContainer = $('#currencies-container');
const $currencySelect = $('select.currency-selector');
if($fakeCurrencySelector.length > 0 && $fakeCurrencySelected.length > 0 && $fakeCurrencyContainer.length > 0) {
  $fakeCurrencySelected.on('click', ()=> {
    $fakeCurrencyContainer.toggleClass('open');
    $fakeCurrencySelected.toggleClass('hide');
  });

  const $singleCurrencies = $fakeCurrencySelector.find('.single-currency');
  $singleCurrencies.each( function() {
    $(this).on('click', ()=> {
      var $newCurrency = $(this).attr('data-currency-code');
      $fakeCurrencySelected.toggleClass('hide');
      $fakeCurrencyContainer.toggleClass('open');
      $currencySelect.val($newCurrency).trigger('change');
    });
  })
}
